import "/home/runner/work/pocket-dimension-dice/pocket-dimension-dice/components/Rollable/components/RollContextMenu/styles.module_built.css";
const classes = {"section":"_9OLh5G_section","adjustmentColumn":"_9OLh5G_adjustmentColumn","svg":"_9OLh5G_svg","rollButton":"_9OLh5G_rollButton","dmgRollOption":"_9OLh5G_dmgRollOption","toggleSwitchWrapper":"_9OLh5G_toggleSwitchWrapper","heading":"_9OLh5G_heading","adjustDiceButton":"_9OLh5G_adjustDiceButton","check":"_9OLh5G_check","diceAdjustmentContainer":"_9OLh5G_diceAdjustmentContainer","rollButtonTextSlot":"_9OLh5G_rollButtonTextSlot","list":"_9OLh5G_list","rollButtonText":"_9OLh5G_rollButtonText","menu":"_9OLh5G_menu","rotateIcon":"_9OLh5G_rotateIcon","dieIcon":"_9OLh5G_dieIcon","adjustDiceColumnText":"_9OLh5G_adjustDiceColumnText","adjustDiceHeader":"_9OLh5G_adjustDiceHeader","adjustDiceText":"_9OLh5G_adjustDiceText","adjustDiceTempSlot":"_9OLh5G_adjustDiceTempSlot","disabled":"_9OLh5G_disabled","listItemButton":"_9OLh5G_listItemButton","diceNotation":"_9OLh5G_diceNotation","adjustDiceTempText":"_9OLh5G_adjustDiceTempText"}
export default classes

const _section0 = classes["section"]
export { _section0 as "section" }

const _adjustmentColumn0 = classes["adjustmentColumn"]
export { _adjustmentColumn0 as "adjustmentColumn" }

const _svg0 = classes["svg"]
export { _svg0 as "svg" }

const _rollButton0 = classes["rollButton"]
export { _rollButton0 as "rollButton" }

const _dmgRollOption0 = classes["dmgRollOption"]
export { _dmgRollOption0 as "dmgRollOption" }

const _toggleSwitchWrapper0 = classes["toggleSwitchWrapper"]
export { _toggleSwitchWrapper0 as "toggleSwitchWrapper" }

const _heading0 = classes["heading"]
export { _heading0 as "heading" }

const _adjustDiceButton0 = classes["adjustDiceButton"]
export { _adjustDiceButton0 as "adjustDiceButton" }

const _check0 = classes["check"]
export { _check0 as "check" }

const _diceAdjustmentContainer0 = classes["diceAdjustmentContainer"]
export { _diceAdjustmentContainer0 as "diceAdjustmentContainer" }

const _rollButtonTextSlot0 = classes["rollButtonTextSlot"]
export { _rollButtonTextSlot0 as "rollButtonTextSlot" }

const _list0 = classes["list"]
export { _list0 as "list" }

const _rollButtonText0 = classes["rollButtonText"]
export { _rollButtonText0 as "rollButtonText" }

const _menu0 = classes["menu"]
export { _menu0 as "menu" }

const _rotateIcon0 = classes["rotateIcon"]
export { _rotateIcon0 as "rotateIcon" }

const _dieIcon0 = classes["dieIcon"]
export { _dieIcon0 as "dieIcon" }

const _adjustDiceColumnText0 = classes["adjustDiceColumnText"]
export { _adjustDiceColumnText0 as "adjustDiceColumnText" }

const _adjustDiceHeader0 = classes["adjustDiceHeader"]
export { _adjustDiceHeader0 as "adjustDiceHeader" }

const _adjustDiceText0 = classes["adjustDiceText"]
export { _adjustDiceText0 as "adjustDiceText" }

const _adjustDiceTempSlot0 = classes["adjustDiceTempSlot"]
export { _adjustDiceTempSlot0 as "adjustDiceTempSlot" }

const _disabled0 = classes["disabled"]
export { _disabled0 as "disabled" }

const _listItemButton0 = classes["listItemButton"]
export { _listItemButton0 as "listItemButton" }

const _diceNotation0 = classes["diceNotation"]
export { _diceNotation0 as "diceNotation" }

const _adjustDiceTempText0 = classes["adjustDiceTempText"]
export { _adjustDiceTempText0 as "adjustDiceTempText" }
